module.exports = __webpack_public_path__ + "img/14days.56dcdc05.png";